export function paymentReturnLanguage(route) {
  if (route.path !== '/payment/return') return null;
  const language = route.query?.lang;
  return language === 'en' || language === 'ru' ? language : null;
}

export function paymentReturnTarget(value) {
  if (typeof value !== 'string' || !value.startsWith('/payment/return?')) return null;
  try {
    const url = new URL(value, 'https://local.invalid');
    if (url.origin !== 'https://local.invalid' || url.pathname !== '/payment/return') return null;
    return `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
}
